import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantService } from '../services/tenant.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  constructor(private _tenantService: TenantService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenant = this._tenantService.activeTenantId;
    if (!tenant) {
      return next.handle(req);
    }

    const tenantReq = req.clone({
      setHeaders: {
        'x-tenant-id': tenant,
      },
    });

    return next.handle(tenantReq);
  }
}
